import React from 'react';
import Layout from '../components/Layout';
import ExchangeAccountManager from '../components/ExchangeAccountManager';

const TuongTacCheo: React.FC = () => (
  <Layout>
    <ExchangeAccountManager
      platform="tuongtaccheo"
      title="Tương Tác Chéo"
      description="Quản lý account Tương Tác Chéo, import tài khoản, đăng nhập lấy cookie/token và cập nhật số dư."
      showTtcMetrics
    />
  </Layout>
);

export default TuongTacCheo;